export const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];

export const validDocumentTypes = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
  "application/msword", // doc
  "application/vnd.ms-excel", // xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
  "application/vnd.ms-powerpoint", // ppt
  "application/vnd.openxmlformats-officedocument.presentationml.presentation", // pptx
  "application/zip",
  "application/x-zip-compressed",
  "multipart/x-zip",
  "application/x-compressed",
  "application/octet-stream",
  "application/x-rar-compressed",
  "application/x-7z-compressed",
  "text/plain",
];

export const validExtensions = [
  "jpg", "jpeg", "png",
  "pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx",
  "zip", "rar", "7z", "txt"
];

export const isAllowedFile = (file) => {
  if (!file) return false;
  const extension = file.name.split('.').pop().toLowerCase();
  const isTypeValid = validImageTypes.includes(file.type) || validDocumentTypes.includes(file.type);
  const isExtensionValid = validExtensions.includes(extension);
  return isTypeValid && isExtensionValid;
};

export const MAX_FILE_LIMIT = 5;

